"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectField = void 0;
const create_field_component_1 = __importDefault(require("../form-group/create-field-component"));
const select_1 = __importDefault(require("./select"));
exports.SelectField = (0, create_field_component_1.default)(select_1.default);
exports.default = exports.SelectField;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VsZWN0LWZpZWxkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vY29tcG9uZW50cy9zZWxlY3Qvc2VsZWN0LWZpZWxkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGtHQUF3RTtBQUN4RSxzREFBK0M7QUFFbEMsUUFBQSxXQUFXLEdBQUcsSUFBQSxnQ0FBb0IsRUFBYyxnQkFBTSxDQUFDLENBQUM7QUFDckUsa0JBQWUsbUJBQVcsQ0FBQyJ9